import React, { useState } from 'react';
import ModalContext from './ModalContext';
import PropTypes from 'prop-types';
import AppModal from './AppModal';

const ModalWrapper = ({ children }) => {
    const [modalStack, setModalStack] = useState([]);
    return (
        <ModalContext.Provider value={{ modalStack, setModalStack }}>
            {children}
            {modalStack
                .filter((modal) => modal.isOpen)
                .map((modal) => (
                    <AppModal key={modal.id} {...modal} />
                ))}
        </ModalContext.Provider>
    );
};
ModalWrapper.propTypes = {
    children: PropTypes.any,
};
export default ModalWrapper;